import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import './Testimonials.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'; 
import testimonialsImg from '../../assets/Frontpage_ladder-scaled-aspect-ratio-5-3-2048x1229.webp'


const testimonials = [
    {
        title: 'Product Delivery',
        text: 'We cut manual work by 80% and now get real-time insights for climate-based crop research.',
        authorName: 'Dr. U. Satish Kumar',
        authorLocation: 'Dean, University of Agricultural Sciences',
    },
    // {
    //     title: 'Product Delivery',
    //     text: 'Our profile report generation is faster, secure, and fully automated.',
    //     authorName: 'Hong Wai',
    //     authorLocation: 'Product Manager, SCCB',
    // },
    // Add more testimonials as needed
];
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  arrows: false, // This will remove the arrow buttons
};

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const sliderRef = useRef(null); // Add slider reference

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Handle previous slide
  const handlePrevious = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  // Handle next slide
  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-content">
          <div className="testimonials-image">
            <img
              src={testimonialsImg}
              alt="Professional woman sitting on steps"
            />
          </div>
          <div className="testimonials-text">
            <h2 className="testimonials-title">What our clients say</h2>
            <div className={`testimonial-section ${isVisible ? 'animate-in' : ''}`} ref={sectionRef}>
              <div className="testimonial-content slide-in-left">
                <Slider {...settings} ref={sliderRef}>
                  {testimonials.map((testimonial, index) => (
                    <div key={index}>
                      <h2 className="testimonial-title">{testimonial.title}</h2>
                      <p className="testimonial-text">{testimonial.text}</p>
                      <div className="testimonial-author">
                        <strong className="author-name">{testimonial.authorName}</strong>
                        <span className="author-location">{testimonial.authorLocation}</span>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            <div className="clients-navigation">
              <button
                className="nav-btn prev-btn"
                aria-label="Previous"
                onClick={handlePrevious}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button
                className="nav-btn next-btn"
                aria-label="Next"
                onClick={handleNext}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;